import { createContext, useContext, useState, useCallback } from "react";

const translations = {
  it: {
    "brand.title": "Spazio Clienti",

    "home.eyebrow": "RB Studio",
    "home.title": "Come possiamo aiutarti?",
    "home.subtitle": "Scegli un'opzione qui sotto per iniziare.",
    "home.doc.title": "Invio documenti",
    "home.doc.desc": "Carica i tuoi documenti in modo sicuro. Direttamente da foto o file.",
    "home.app.title": "Fissa un appuntamento",
    "home.app.desc": "Prenota una consulenza online o in presenza con lo studio.",
    "home.pay.title": "Invia un pagamento",
    "home.pay.desc": "Bonifico bancario, PayPal o carta di credito.",
    "home.staff": "Area riservata",

    "doc.eyebrow": "Invio documenti",
    "doc.title": "Invia i tuoi documenti",
    "doc.subtitle": "Compila i tuoi dati e carica i documenti richiesti. I file verranno inviati in modo sicuro allo studio.",
    "doc.cognome": "Cognome",
    "doc.nome": "Nome",
    "doc.telefono": "Numero di telefono",
    "doc.ph.cognome": "Es. Rossi",
    "doc.ph.nome": "Es. Mario",
    "doc.ph.telefono": "Es. +39 333 1234567",
    "doc.documenti": "Documenti",
    "doc.documento": "Documento",
    "doc.tipo": "Tipo di documento",
    "doc.seleziona": "Seleziona...",
    "doc.specifica": "Specifica il documento",
    "doc.ph.specifica": "Es. Certificato matrimonio",
    "doc.carica": "CARICA",
    "doc.caricaHint": "Fotocamera o file (PDF, JPG, PNG)",
    "doc.tocca": "Tocca per sostituire",
    "doc.aggiungi": "Aggiungi un altro documento",
    "doc.privacyPre": "Dichiaro di aver preso visione dell'",
    "doc.privacyLink": "informativa sul trattamento dei dati personali",
    "doc.invia": "INVIA",
    "doc.invioInCorso": "Invio in corso...",
    "doc.formati": "Formati accettati: PDF, JPG, PNG · max 20MB per file",
    "doc.error": "Errore durante l'invio. Riprova.",
    "doc.successTitle": "Documenti inviati!",
    "doc.docsSent": (n) => `Hai inviato ${n} ${n === 1 ? "documento" : "documenti"}:`,
    "doc.notified": "Lo studio è stato notificato e prenderà in carico la tua richiesta.",
    "doc.fissa": "Fissa un appuntamento",
    "doc.whatsapp": "Scrivici su WhatsApp",
    "doc.inviaAltri": "Invia altri documenti",

    "pay.title": "Invia un pagamento",
    "pay.subtitle": "Scegli la modalità di pagamento che preferisci.",
    "pay.bonifico": "Bonifico bancario",
    "pay.bonificoSub": "Coordinate per il trasferimento",
    "pay.intestatario": "Intestatario",
    "pay.banca": "Banca",
    "pay.bicCorr": "BIC banca corrispondente",
    "pay.notePre": "Ti consigliamo di indicare nome, cognome e causale nel bonifico. Puoi inviarci la ricevuta dalla sezione ",
    "pay.noteLink": "Invio documenti",
    "pay.paypalSub": "Pagamento rapido con il tuo account PayPal",
    "pay.carta": "Carta di credito",
    "pay.cartaSub": "Pagamento sicuro con carta · SumUp",
    "pay.cartaPaga": "Paga",
    "pay.sumupTitle": "Pagamento con carta",
    "pay.sumupFallback": "Se la pagina non si carica correttamente, ",
    "pay.sumupFallbackLink": "aprila a tutto schermo",
    "pay.inArrivo": "In arrivo",
    "pay.copied": (label) => `${label} copiato`,
    "pay.copyFail": "Impossibile copiare",
    "pay.paypalToast": "PayPal sarà disponibile a breve.",
    "pay.cartaToast": "Il pagamento con carta sarà disponibile a breve.",
  },
  en: {
    "brand.title": "Client Area",

    "home.eyebrow": "RB Studio",
    "home.title": "How can we help you?",
    "home.subtitle": "Choose an option below to get started.",
    "home.doc.title": "Send documents",
    "home.doc.desc": "Upload your documents securely — straight from a photo or file.",
    "home.app.title": "Book an appointment",
    "home.app.desc": "Book a consultation online or in person with the firm.",
    "home.pay.title": "Make a payment",
    "home.pay.desc": "Bank transfer, PayPal or credit card.",
    "home.staff": "Staff area",

    "doc.eyebrow": "Send documents",
    "doc.title": "Send your documents",
    "doc.subtitle": "Fill in your details and upload the required documents. Files are sent securely to the firm.",
    "doc.cognome": "Surname",
    "doc.nome": "First name",
    "doc.telefono": "Phone number",
    "doc.ph.cognome": "e.g. Rossi",
    "doc.ph.nome": "e.g. Mario",
    "doc.ph.telefono": "e.g. +39 333 1234567",
    "doc.documenti": "Documents",
    "doc.documento": "Document",
    "doc.tipo": "Document type",
    "doc.seleziona": "Select...",
    "doc.specifica": "Specify the document",
    "doc.ph.specifica": "e.g. Marriage certificate",
    "doc.carica": "UPLOAD",
    "doc.caricaHint": "Camera or file (PDF, JPG, PNG)",
    "doc.tocca": "Tap to replace",
    "doc.aggiungi": "Add another document",
    "doc.privacyPre": "I confirm I have read the ",
    "doc.privacyLink": "privacy policy on the processing of personal data",
    "doc.invia": "SEND",
    "doc.invioInCorso": "Sending...",
    "doc.formati": "Accepted formats: PDF, JPG, PNG · max 20MB per file",
    "doc.error": "Something went wrong. Please try again.",
    "doc.successTitle": "Documents sent!",
    "doc.docsSent": (n) => `You sent ${n} ${n === 1 ? "document" : "documents"}:`,
    "doc.notified": "The firm has been notified and will take care of your request.",
    "doc.fissa": "Book an appointment",
    "doc.whatsapp": "Message us on WhatsApp",
    "doc.inviaAltri": "Send more documents",

    "pay.title": "Make a payment",
    "pay.subtitle": "Choose your preferred payment method.",
    "pay.bonifico": "Bank transfer",
    "pay.bonificoSub": "Transfer details",
    "pay.intestatario": "Account holder",
    "pay.banca": "Bank",
    "pay.bicCorr": "Correspondent bank BIC",
    "pay.notePre": "We recommend including your name, surname and a reference in the transfer. You can send us the receipt from the ",
    "pay.noteLink": "Send documents",
    "pay.paypalSub": "Fast payment with your PayPal account",
    "pay.carta": "Credit card",
    "pay.cartaSub": "Secure card payment · SumUp",
    "pay.cartaPaga": "Pay",
    "pay.sumupTitle": "Card payment",
    "pay.sumupFallback": "If the page doesn't load correctly, ",
    "pay.sumupFallbackLink": "open it full screen",
    "pay.inArrivo": "Coming soon",
    "pay.copied": (label) => `${label} copied`,
    "pay.copyFail": "Couldn't copy",
    "pay.paypalToast": "PayPal will be available soon.",
    "pay.cartaToast": "Card payment will be available soon.",
  },
};

const LangContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("rb_lang") || "it");
  const setLang = useCallback((l) => {
    localStorage.setItem("rb_lang", l);
    setLangState(l);
  }, []);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const t = useCallback(
    (key, arg) => {
      const v = translations[lang]?.[key] ?? translations.it[key] ?? key;
      return typeof v === "function" ? v(arg) : v;
    },
    [lang]
  );
  return <LangContext.Provider value={{ lang, setLang, t }}>{children}</LangContext.Provider>;
}

export function useT() {
  const ctx = useContext(LangContext);
  if (!ctx) return { lang: "it", setLang: () => {}, t: (k) => translations.it[k] ?? k };
  return ctx;
}
